// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3f1EF","footer":"styles_footer__3z3FL"};